/**
 * Drops the language-specific facet filters when the shopper switches language.
 *
 * The localization form posts a `return_to` value holding the current path and
 * query string. Filter values are the translated data itself — a jacket is
 * `filter.p.product_type=Jacket` in English and `=Jacke` in German — so a
 * filter picked in one language matches nothing after switching, leaving the
 * shopper on an empty collection.
 *
 * Translating the value client-side is not possible (the translations live in
 * Shopify's search index), so the translated filters are dropped instead.
 * Filters that mean the same thing in every language — availability, price,
 * tags, vendors and numeric values — are kept, as is the rest of the query
 * string such as `sort_by` or `q`.
 */
(function () {
  'use strict';

  // Filter keys whose values are not translated, so they stay valid.
  var LOCALE_SAFE_KEYS = [
    /^filter\.v\.availability$/,
    /^filter\.v\.price\./,
    /^filter\.p\.tag$/,
    /^filter\.p\.vendor$/
  ];

  // Variant option filters carry the option name in the key itself
  // (`filter.v.option.size` becomes `filter.v.option.größe`), so they never
  // survive a switch, whatever their value.
  var TRANSLATED_KEYS = [/^filter\.v\.option\./];

  var NUMERIC_VALUE = /^-?\d+(\.\d+)?$/;

  function matches(patterns, key) {
    return patterns.some(function (pattern) {
      return pattern.test(key);
    });
  }

  function isTranslatedFilter(key, value) {
    if (key.indexOf('filter.') !== 0) {
      return false;
    }

    if (matches(TRANSLATED_KEYS, key)) {
      return true;
    }

    if (matches(LOCALE_SAFE_KEYS, key)) {
      return false;
    }

    // A numeric value (an inseam, a rating, a metafield range) reads the same
    // in every language.
    return !NUMERIC_VALUE.test(value);
  }

  function pathForNewLocale() {
    var url = new URL(window.location.href);
    var kept = new URLSearchParams();
    var dropped = false;

    url.searchParams.forEach(function (value, key) {
      if (isTranslatedFilter(key, value)) {
        dropped = true;
      } else {
        kept.append(key, value);
      }
    });

    // Fewer filters means fewer pages, so the current page number may no
    // longer exist.
    if (dropped) {
      kept.delete('page');
    }

    var query = kept.toString();

    return url.pathname + (query ? '?' + query : '');
  }

  function isLocaleSubmission(form, submitter) {
    if (submitter) {
      return submitter.name === 'locale_code';
    }

    // Older browsers without `event.submitter`: treat a form that only offers
    // language buttons as a language switch.
    return (
      form.querySelector('[name="locale_code"]') !== null &&
      form.querySelector('[name="country_code"]') === null
    );
  }

  document.addEventListener('submit', function (event) {
    var form = event.target;

    if (!(form instanceof HTMLFormElement) || !isLocaleSubmission(form, event.submitter)) {
      return;
    }

    // The localization form renders its own `return_to`; the last one posted
    // wins, so rewrite in place rather than appending a second field.
    var returnTo = form.querySelector('input[name="return_to"]');

    if (!returnTo) {
      returnTo = document.createElement('input');
      returnTo.type = 'hidden';
      returnTo.name = 'return_to';
      form.appendChild(returnTo);
    }

    returnTo.value = pathForNewLocale();
  });
})();
